import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { optionsApi } from '../../constants/options-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { specificUserParams, userParams } from '../../helpers/helperfunc';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { formMasterApi } from '../../constants/form-master-api';

@Injectable({
  providedIn: 'root'
})
export class FormMasterService {
  permissions_entity = permissionEntity;
  
  constructor(
    private httpClientService: HttpClientService,
    private _permissionPipe: PermissionsPipe // dont remove this
  ) {}

  getFormForModule(pagination: PaginationType): Observable<any> {
      let query = '?';
      query += userParams.call(this, this.permissions_entity.modules.options);
      query += `skip=${pagination.skip}&limit=${pagination.limit}`;
      return this.httpClientService.get(`${formMasterApi.getForms}${query}`);
  }

  createOptions(payload: any): Observable<any> {
      return this.httpClientService.post(
        formMasterApi.createformsMaster,
          payload
      );
  }

  editOptions(id: any, payload: any): Observable<any> {
      return this.httpClientService.put(`${formMasterApi.editOptions}?Id=${id}`, payload);
  }

  deteleOptions(id: any): Observable<any> {
      return this.httpClientService.delete(`${optionsApi.deteleOptions}?Id=${id}`);
  }

  getOptionById(id: any): Observable<any> {
    return this.httpClientService.get(`${formMasterApi.getFormByID}${id}`);
  }

  getOptionsForCourseType(): Observable<any> {
    return this.httpClientService.get(`${optionsApi.getOptionCouserType}`);
  }

  getOptionsForUniversityDocumentType(): Observable<any> {
    return this.httpClientService.get(`${optionsApi.getOptionsForUniversityDocumentType}`);
  }

  getOptionsForApplicationType(): Observable<any> {
    return this.httpClientService.get(`${optionsApi.getOptionsForApplicationType}`);
  }

  getOptionsForIntake(): Observable<any> {
    return this.httpClientService.get(`${optionsApi.getOptionsForIntake}`);
  }

  getOptionsForMarksheetType(): Observable<any> {
    return this.httpClientService.get(`${optionsApi.getOptionsForMarksheetType}`);
  }

  getOptionsForMarksheetSection(): Observable<any> {
    return this.httpClientService.get(`${optionsApi.getOptionsForMarksheetSection}`);
  }

  getOptionsForPreviousAcadmicCourse(): Observable<any> {
    return this.httpClientService.get(`${optionsApi.getOptionsForPreviousAcadmicCourse}`);
  }

  getOptionsForCampus(): Observable<any> {
    return this.httpClientService.get(`${optionsApi.getOptionsForCampus}`);
  }

  saveForm(payload: any): Observable<any> {
    return this.httpClientService.post(`${formMasterApi.saveForm}`, payload);
  }

  getOptionUniversityId(id: any): Observable<any> {
    return this.httpClientService.get(`${formMasterApi.getUniversityID}${id}`);
  }

}
